import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getPropertiesApi, createPropertyApi } from '../api/property';
import { useToast } from '../context/ToastContext';

const KEY = ['properties'];

export const useProperties = () =>
  useQuery({ queryKey: KEY, queryFn: getPropertiesApi });

export const useCreateProperty = () => {
  const qc = useQueryClient();
  const { success, error } = useToast();
  return useMutation({
    mutationFn: createPropertyApi,
    onSuccess: () => { qc.invalidateQueries({ queryKey: KEY }); success('Property added!'); },
    onError:   (e) => error(e?.message || 'Failed to add property.'),
  });
};
